var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.noPadding &&
    _vm.entity.logs_url &&
    Object.entries(_vm.entity.logs_url) &&
    _vm.isEmployee &&
    !_vm.isSection
      ? _c("hr", { staticClass: "emd-divider eu-bg_300 eu-my_4" })
      : _vm._e(),
    _vm.entity.logs_url &&
    Object.entries(_vm.entity.logs_url).length &&
    _vm.isEmployee
      ? _c(
          "div",
          [
            _vm.isSection
              ? _c(
                  "jade-box",
                  { staticClass: "eu-mt_5 eu-mb_3 el-section eu-fade-in" },
                  [
                    _c("jade-group-header", [_vm._v(_vm._s(_vm.title))]),
                    _c(
                      "div",
                      { staticClass: "flex flex-col gap-5 p-5" },
                      [
                        _c("log-link-content", {
                          attrs: {
                            isSection: _vm.isSection,
                            entity: _vm.entity,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c(
                      "jade-text",
                      { attrs: { variant: "heading-xsmall", color: "high" } },
                      [_vm._v(" " + _vm._s(_vm.title))]
                    ),
                    _c(
                      "div",
                      [
                        _c("log-link-content", {
                          attrs: {
                            isSection: _vm.isSection,
                            entity: _vm.entity,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }